import { Injectable } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ModalStateService {
  private modalRef: NgbModalRef | null = null

  constructor(private modalService: NgbModal) { }

  openModal(component: any): void {
    if (!this.modalRef) {
      this.modalRef = this.modalService.open(component, {
        animation: false
      })

    }
  }

  closeModal(): void {
    if(this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }
}
